import { WarrantyLogInput, WarrantyLogNoteInput, WarrantyLogService } from 'api-new/generated';
import { QueryError } from 'features/shared/model';
import { UseMutationOptions, useMutation } from 'react-query';

type WarrantyLogAddNoteInput = {
  logId: number;
  requestBody?: WarrantyLogNoteInput;
};

export const useWarrantyLogAddNoteMutation = (
  options?: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof WarrantyLogService.postWarrantyLogNote>>,
      QueryError,
      WarrantyLogAddNoteInput,
      unknown
    >,
    'mutationFn'
  >
) =>
  useMutation(
    (input: WarrantyLogAddNoteInput) => WarrantyLogService.postWarrantyLogNote(input.logId, input.requestBody),
    options
  );
